import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {debounceTime, finalize, take} from 'rxjs/operators';
import {timer} from 'rxjs';
import {FormErrorValidatorService} from '../../services/form-error-validator.service';
import {ResetPasswordVm} from '../../../../view-model/reset-password/reset-password.vm';
import {emailFormatValidator} from '../../custom-validators/email-format-validator';

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss'],
  providers: [FormBuilder],
})
export class ResetPasswordFormComponent implements OnInit {
  @Input() idPrefix = '';
  @Input() supportButton = false;
  @Output() passwordReset = new EventEmitter<any>();
  resetPasswordForm: FormGroup;
  isLoading = false;
  error = {email: ''};
  formConfig = {email: 100};
  errorObj: any = null;
  successMessage = '';

  constructor(private formBuilder: FormBuilder,
              private fev: FormErrorValidatorService,
              private vm: ResetPasswordVm) { }

  init() {
    this.resetPasswordForm = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.maxLength(this.formConfig.email),
        emailFormatValidator,
      ]),
    });

    this.resetPasswordForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(values => {
        this.errorObj = null;
        this.fev.resetPasswordFormErrorValidator(values, this.resetPasswordForm, this.error);
      });
  }

  reset() {
    if (this.resetPasswordForm.valid) {
      this.isLoading = true;
      this.errorObj = null;
      this.vm.resetPassword(this.resetPasswordForm.value)
        .pipe(finalize(() => { this.isLoading = false; }))
        .subscribe(response => {
          this.successMessage = response.message ? response.message : 'Se ha enviado un correo de recuperación de contraseña.';
          timer(3000)
            .pipe(take(1))
            .subscribe(() => {
              this.passwordReset.emit(response.confirmation);
          });
        }, error => {
          this.errorObj = error;
        });
    }
  }

  ngOnInit() {
    this.init();
  }
}
